import { KameleoonGoalData } from '@/hooks/kameleoon/kameleoonGoals';
import { useTrackConversion } from '@/hooks/kameleoon/useTrackConversion';

export const useTrackBidPlacedOnItemPage = () =>
    useTrackConversion({
        goal: KameleoonGoalData.BidPlacedItemPage,
    });
